var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 421,
    viewBox: "0 0 1440 421",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 156L0 0V421H1440V156Z",
    fill: "#2F91F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 156L1440 0V421H0V156Z",
    fill: "#C8F22B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterbg);
export default __webpack_public_path__ + "static/media/footerbg.57f5d9f82071a15e6d56892d96e35250.svg";
export { ForwardRef as ReactComponent };